import SparkIcon from './index.vue';

export default SparkIcon;
